export const SrNo = 'Sr. No.'
export const Position = 'Position'
export const PositionList = 'Position List'
export const DeleteMessage = 'Are you sure you want to Delete this item?'